import React from 'react';
import classNames from 'classnames';

import css from './IconChevronToggle.module.css';

/**
 * IconChevronToggle component
 *
 * A right-pointing chevron that rotates downward when open.
 * Mirrors the API of IconPlus so it can be used as a drop-in replacement.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {boolean} [props.isOpen] - Whether the icon is showing the 'open' (downward) mode
 * @returns {JSX.Element}
 */
const IconChevronToggle = props => {
  const { className, rootClassName, isOpen = false } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.open]: isOpen,
  });

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M5.62187 0.631394C4.79271 1.46964 4.79271 2.82372 5.62187 3.66196L13.8709 12.0013L5.62187 20.3408C4.79271 21.179 4.79271 22.5331 5.62187 23.3713C6.45102 24.2096 7.79043 24.2096 8.61959 23.3713L18.3781 13.5059C19.2073 12.6676 19.2073 11.3135 18.3781 10.4753L8.61959 0.609901C7.81169 -0.206847 6.45102 -0.206848 5.62187 0.631394Z"
        fill="inherit"
      />
    </svg>
  );
};

export default IconChevronToggle;
